import { ProductType } from '../../common';
import { getPricingApiConfig } from '../api/pricing-api';
import { getProductTypeUrlParameter } from './get-product-type-url-parameter';
import { getProductTypeUrlSuffix } from './get-product-type-url-suffix';

export const getFetchPricesUrl = (
  entityIds: number[],
  productType = ProductType.Family
): string => {
  const { baseUrl, marketLocale } = getPricingApiConfig();
  const suffix = getProductTypeUrlSuffix(productType);
  const idUrlParameter = getProductTypeUrlParameter(productType);
  const idUrlComponent = `${idUrlParameter}=${entityIds.join(`&${idUrlParameter}=`)}`;

  return `${baseUrl}/v1/${suffix}?${idUrlComponent}&marketLocale=${marketLocale}`;
};
